/* eslint-disable arrow-body-style */
import React from 'react';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { pageConfig } from './pageConfig';

//  poe2 新版funnel页面
const reqParams = '/funnel/registerFunnelDaily';
const SalesOverview = () => {
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageConfig} />
    </>
  );
};

export default SalesOverview;